import type { IconName } from "@similarweb/icons";

export const devicesTypes = {
    MOBILE: "MobileWeb",
    DESKTOP: "Desktop",
    TOTAL: "Total",
} as const;

export type DeviceType = (typeof devicesTypes)[keyof typeof devicesTypes];

export enum EDeviceType {
    MOBILE = "MobileWeb",
    DESKTOP = "Desktop",
    TOTAL = "Total",
}

export enum DEVICES_TYPES_FOR_API {
    MOBILE = "Mobile",
    DESKTOP = "Desktop",
    TOTAL = "Total",
    COMBINED = "Both",
}

export const webSourceIcon = (webSource: string): IconName | undefined => {
    switch (webSource) {
        case devicesTypes.DESKTOP:
            return "desktop";
        case devicesTypes.MOBILE:
            return "mobile-web";
        case devicesTypes.TOTAL:
            return "combined";
    }
};

export const MOBILE_WEB = "mobileweb";

/** True for route (`devicesTypes.MOBILE`) or API (`DEVICES_TYPES_FOR_API.MOBILE`) mobile spellings. */
export const isMobileDevice = (device: string | undefined): boolean =>
    device === devicesTypes.MOBILE || device === DEVICES_TYPES_FOR_API.MOBILE;

export const webSourceToDeviceForApi = {
    [devicesTypes.DESKTOP]: DEVICES_TYPES_FOR_API.DESKTOP,
    [devicesTypes.MOBILE]: DEVICES_TYPES_FOR_API.MOBILE,
    [devicesTypes.TOTAL]: DEVICES_TYPES_FOR_API.TOTAL,
};
